module.exports = __webpack_public_path__ + "app/img/gift-icon.7af41aa2.png";